module.exports = __webpack_public_path__ + "media/feature-icons/Calculations-90942867.svg";